module.exports = [{"id":1,"title":"3D Image","image":"score_1.gif","url":""},{"id":2,"title":"Cards Grid","image":"score_2.jpg","url":"https://thegetty.github.io/scores-interactive/brecht/water-yam/"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/brecht/score.yml
// module id = DaSc
// module chunks = 0